import React, { Component } from 'react';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './store/actions/index';
import './App.css';
import firebase from './firebase';

import Auth from './containers/Auth/Auth';
import Layout from './containers/Layout/Layout';
import HomePage from './components/HomePage/HomePage';
import Logout from './containers/Auth/Logout';
import User from './containers/User/User';
import VerifyEmail from './containers/Auth/VerifyEmail';
import Contact from './components/Contact/Contact';
import Equipment from './components/Equipment/Equipment';
import BookClass from './components/Class/Class';
import SignUp from './containers/Auth/SignUp';
import Staff from './containers/Staff/Staff';
import ResourceCalendar from './containers/ResourceCalendar/ResourceCalendar';
import GoogleCalendar from './containers/GoogleCalendar/GoogleCalendar';
import BlogHomePage from './containers/Blog/Read/Index';

class App extends Component {
  componentDidMount () {
    firebase.auth().onAuthStateChanged( user => {
      if( user ) {
        this.updateAuthState( user.uid );
      }
    } )
  }

  updateAuthState = ( id ) => {
    this.props.updateAuthState( id );
  }


  render () {
    let role = 'user';
    let routes = (
      <Switch>
        <Route path={[ '/blog/:id', '/blog' ]} component={BlogHomePage} />
        <Route path='/auth' exact component={Auth} />
        <Route path='/contact' exact component={Contact} />
        <Route path='/class' exact component={BookClass} />
        <Route path='/equipment' exact component={Equipment} />
        <Route path='/signup' exact component={SignUp} />
        <Route path='/resources' exact component={ResourceCalendar} />
        <Route path='/calendar' exact component={GoogleCalendar} />
        <Route path='/' exact component={HomePage} />
      </Switch>
    );

    if( this.props.isLoggedIn ) {
      role = this.props.user.role;
      if( !this.props.emailVerified ) {
        routes = (
          <Switch>
            <Route path='/logout' exact component={Logout} />
            <Route path='/' component={VerifyEmail} />
          </Switch>
        );
      } else {
        routes = (
          <Switch>
            <Route path={[ '/blog/:id', '/blog' ]} component={BlogHomePage} />
            <Route path='/contact' exact component={Contact} />
            <Route path='/class' exact component={BookClass} />
            <Route path='/equipment' exact component={Equipment} />
            <Route path='/logout' exact component={Logout} />
            <Route path='/staff' exact component={Staff} />
            <Route path='/resources' exact component={ResourceCalendar} />
            <Route path='/calendar' exact component={GoogleCalendar} />
            <Route path='/:id' exact component={User} />
            <Route path='/' exact component={HomePage} />
          </Switch>
        );
      }
    }
    return (
      <Layout role={role} isLoggedIn={this.props.isLoggedIn} currentId={this.props.currentId}>
        {routes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.currentUser !== null,
    emailVerified: state.auth.emailVerified,
    currentId: state.auth.currentId,
    user: state.auth.currentUser
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updateAuthState: ( id ) => dispatch( actions.updateAuthState( id ) )
  }
}


export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );
